<template>
  <div :class="['item', {'selected': model}]" @click.prevent="onSelect">
    <base-checkbox class="checkbox" v-model="model" />
    <div class="avatar rounded-circle">
      <img :src="avatarUrl" />
    </div>
    <span class="name">
      {{name}}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    avatarUrl: String,
    selected: Boolean,
  },
  data() {
    return {
    };
  },
  computed: {
    model: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('changed', value);
      },
    },
  },
  methods: {
    onSelect() {
      this.$emit('changed', !this.selected);
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  padding: .5rem;
  border-bottom: 1px solid #f5f5f5;
  transition: all .5s;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border: 1px solid white;
  }

  .name {
    padding-left: 1rem;
    transition: all .25s;
  }

  .checkbox {
    margin-left: .75rem;
    margin-right: -.75rem;
  }

  &.selected {
    background: #5e72e4;
    border-bottom: 1px solid rgba(255,255,255,.25);

    .name {
      color: white;
    }
  }
}
</style>
